import React from "react"

import AddressAutocomplete from "./AddressAutocomplete"
import { useProcessBookingAddress } from "../../hooks/useProcessBookingAddress"
import Loading from "./Loading"

interface Props {
  doRedirect: boolean
  lessonType?: string
  placeholder?: string
  incompleteAddressCallback?: (incomplete: boolean) => void
}

const LocationSearchInput = ({
  placeholder,
  incompleteAddressCallback,
  doRedirect,
  lessonType,
}: Props) => {
  const [isSearching, setIsSearching] = React.useState(false)

  const processAddress = useProcessBookingAddress({
    incompleteAddressCallback,
    setIsSearching,
    doRedirect,
    lessonType,
  })

  if (isSearching) return <Loading />

  return (
    <>
      <AddressAutocomplete
        labelText="Complete Address"
        callback={processAddress}
        placeholderText={placeholder || "Address where you want your lesson"}
        searchingCallback={() => setIsSearching(true)}
        callbackPartial={false}
      />
    </>
  )
}

export default LocationSearchInput
